import MemDaily from './mem-daily.vue'
export default MemDaily
